import moment from "moment";
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from 'reducers';
import { HomeService } from 'services';
import { Globals } from "utils";

const AdsTable = () => {
  const nav = useHistory();
  const user = useSelector((state: RootState) => state.user);
  const [data, setData] = useState<any[]>([]);

  const getData = async () => {
    try {
      const res: any = await HomeService.affiliate.getAdvertisements({ user_id: user?.id, type: 2 });
      if (res?.advertisements?.rows) {
        let rows = res.advertisements.rows;
        rows.sort((a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
        setData(rows);
      }

    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="banner-registry">
      <div className="banner-registry__header">
        <h2 className="banner-registry__title">Registro de Banners contratados</h2>
        <button
          className="btn-view-more"
          onClick={() => nav.push('/affiliate/ads')}
          disabled={user?.verification === 0}
          style={{
            opacity: user?.verification === 0 ? 0.5 : 1,
            cursor: user?.verification === 0 ? 'not-allowed' : 'pointer'
          }}
        >
          Ver más
        </button>
      </div>

      <div className="banner-registry__table">
        <div className="table-header">
          <span>Banner</span>
          <span>Duración</span>
          <span>Vencimiento</span>
          <span>Monto</span>
        </div>

        {data.map((hist: any, index: number) => {
          const bannerName = hist.advertising_rate?.name || "Desconocido";
          const bannerAmount = hist.advertising_rate?.amount || "0";
          const formattedExpirationDate = moment(hist.expiration_date).format('DD-MM-YYYY');

          return (
            <div key={index} className="table-row">
              <div className="table-row__item banner-info">
                <img src={Globals.fromPhotos(hist.details?.at(0)?.image)} alt="Miniatura" className="banner-info__img" />
                <span className="banner-info__name">{bannerName}</span>
              </div>
              <div className="table-row__item">{hist.days} días</div>
              <div className="table-row__item">{formattedExpirationDate}</div>
              <div className="table-row__item table-row__item--bold">
                {Globals.formatMiles(Number(bannerAmount) * (Number(hist.days) / 30), true, '$')}
              </div>
            </div>
          )
        })}

        {(!data.length) && (
          <p className="empty">No hay registros</p>
        )}
      </div>
    </section>
  )
}

export default AdsTable